import React, { FC, useMemo } from 'react'

import { useSelector } from 'react-redux'
import { Field, FormSection, formValueSelector } from 'redux-form'

import { Grid } from '@material-ui/core'
import { BaseTextFieldProps } from '@material-ui/core/TextField'

import AutocompleteField from '~/components/fields/AutocompleteField'
import withFormName from '~/containers/withFormName'

import { OptionsProps } from '~/hooks/useOptions'
import { cleaningPairField } from '~/utils/functions'

interface RangeFieldProps extends BaseTextFieldProps {
  name: string
  optionProps: Omit<OptionsProps, 'key'>
  form: any
  min: BaseTextFieldProps & Omit<OptionsProps, 'key'>
  max: BaseTextFieldProps & Omit<OptionsProps, 'key'>
  change?: (field: string, value: any) => void
}

const RangeSection: FC<RangeFieldProps> = ({
  name: fieldName,
  optionProps,
  form,
  min,
  max,
  change
}) => {
  const selector = useMemo(() => formValueSelector(form), [form])
  const value = useSelector((state) => selector(state, fieldName))

  return (
    <FormSection name={fieldName}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Field
            id="min"
            name="min"
            placeholder="Min"
            component={AutocompleteField}
            // @ts-ignore
            size="small"
            getOptionDisabled={(min) => {
              if (!value?.max) return false

              return +min.value > +value.max
            }}
            onChange={
              change ? () => cleaningPairField(fieldName, change) : null
            }
            {...optionProps}
            {...min}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            id="max"
            name="max"
            placeholder="Max"
            component={AutocompleteField}
            // @ts-ignore
            size="small"
            getOptionDisabled={(max) => {
              if (!value?.min) return false

              return +max.value < +value.min
            }}
            onChange={
              change ? () => cleaningPairField(fieldName, change) : null
            }
            {...optionProps}
            {...max}
          />
        </Grid>
      </Grid>
    </FormSection>
  )
}

export default withFormName(RangeSection)
